/**
 * Labstep
 */

import { ResourceLocation } from 'labstep-web/models/resource-location.model';

export const placeholder = `Select ${ResourceLocation.getHumanReadableEntityName()}`;
